import { AxiosPromise } from 'axios';
import { api } from './api';

export class WidgetAPI {
  static getWidgetPointsDetails(id: string | number): AxiosPromise {
    return api.get(`/widget-points/${id}/details.jsonld`);
  }

  static getWidgetGameLink = (gameId: string | number): AxiosPromise => {
    return api.get(`/widget-game/${gameId}/game-url`);
  }
}
